import React from 'react';
import { NAV_ICONS } from '@vanilla/constants/NavIcons.js';

/**
 * Renders a navigation icon from the shared NAV_ICONS SVG map.
 * Sizing is driven by the surrounding CSS (`.crm-nav-icon` / `.crm-nav-subitem`).
 */
const ALLOWED_MARKUP = /^<svg[\s\S]*<\/svg>$/;
// Hardened allowlist: static NAV_ICONS only, block javascript:/data:/vbscript:, event handlers, foreignObject
const BLOCKED_PATTERNS = [/javascript:/i, /data:/i, /vbscript:/i, /on\w+\s*=/i, /<foreignObject/i];
export default function NavIcon({ name }) {
    const markup = NAV_ICONS[name];
    if (!markup || !ALLOWED_MARKUP.test(markup) || BLOCKED_PATTERNS.some((re) => re.test(markup)))
        return <span className="crm-nav-icon" aria-hidden="true"></span>;
    return (
        <span
            className="crm-nav-icon"
            aria-hidden="true"
            dangerouslySetInnerHTML={{ __html: markup }} // eslint-disable-line react/no-danger -- markup validated: <svg> allowlist + blocked javascript:/data:/vbscript:/on*= /foreignObject
        />
    );
}
